import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'app-telecaller-details-grid',
  templateUrl: './telecaller-details-grid.component.html',
  styleUrls: ['./telecaller-details-grid.component.css']
})
export class TelecallerDetailsGridComponent implements OnInit {

  prospects;
  Proj:any={};
  constructor(private userService: UserService,private route: ActivatedRoute,private router: Router, private errorHandler:ErrorHandler) { }

  ngOnInit() {
    this.GetAllTeleUser();
     this.getAllTelecallerAlert()
  }

  GetAllTeleUser() {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllTeleUser()
      .subscribe(
        (data: any) => {
          this.Proj=data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  getAllTelecallerAlert() {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllTelecallerAlert()
      .subscribe(
        (data:any) => {
          this.prospects = data;
          // this.totalItems=data.TotalItemsCount;
          // this.itemsPerPage = itemsPerPage;
          // this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/prospect/telecaller-details/telecaller-details-grid/telecaller-details-grid.component.ts